.filtersIconContainer {
  cursor: pointer;
  position: relative;
  &::before {
    content: "";
    z-index: 1;
    height: 0;
    width: 0;
    transition: height 0.25s ease-out, width ease-out 0.25s, background-color ease-out 0.25s;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 100%;

    @include themify($themes) {
      background-color: themed("main-secondary");
    }
  }

  &:hover,
  &.filtersAreActive {
    &::before {
      height: 34px;
      width: 34px;
      transition: height 0.25s ease-in, width ease-in 0.25s, background-color ease-in 0.25s;
      @include themify($themes) {
        background-color: themed("neutral-tertiary");
      }
    }
  }

  &.filtersAreOpen {
    &::before {
      height: 34px;
      width: 34px;
      transition: height 0.25s ease-in, width ease-in 0.25s, background-color ease-in 0.25s;
      @include themify($themes) {
        background-color: themed("brand-secondary");
      }
    }
  }

  svg {
    position: relative;
    height: 10px;
    width: 12px;
    z-index: 2;
  }
}

.numberOfFilters {
  position: absolute;
  height: 16px;
  width: 16px;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  z-index: 1;

  top: calc(50% - 12px);
  left: calc(50% + 12px);
  transform: translate(-50%, -50%);
  @include themify($themes) {
    background-color: themed("brand-primary");
    border: solid 2px themed("main-secondary");
  }
}

.filtersWrapper {
  max-height: 100%;
  overflow: auto;
  @include themify($themes) {
    .filtersGroupsContainer:not(:last-child) {
      border-bottom: solid 1px themed("neutral-secondary");
      padding-bottom: 18px;
    }
  }
}

.filtersGroupsContainer {
  &:not(:first-child) {
    margin-top: 18px;
  }
  margin-left: 20px;
  margin-right: 20px;
  padding-bottom: 12px;

  &.booleanFiltersWrapper {
    margin-top: 0;
    display: flex;
    flex-direction: column;
    row-gap: 12px;
    .booleanFilterContainer {
      display: flex;
      align-items: center;
      column-gap: 6px;
    }

    p {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
    }
  }
}

.searchFilterContainer {
  padding: 0 20px;
}

.filtersGroupHeader {
  font-size: 11px;
  margin-bottom: 12px;
  @include themify($themes) {
    color: themed("neutral-primary");
  }
}

.filter {
  align-items: flex-end;
  &:not(:last-child) {
    margin-bottom: 12px;
  }
}

.filtersClearAll {
  font-size: 14px;
  position: sticky;
  bottom: 0;
  padding: 20px;
  z-index: 33;
  display: flex;
  justify-content: space-between;

  @include themify($themes) {
    color: themed("main-primary");
    background: themed("main-secondary");
    border-top: solid 1px themed("neutral-secondary");
  }

  span {
    cursor: pointer;
  }
}

.filtersContainer {
  overflow: auto;
  padding-bottom: 8px;

  &.filtersContainerWithBooleanFilters {
    padding-top: 8px;
  }
}

.noResultsContainer {
  padding: 6px 24px;
  margin-bottom: 6px;
  text-align: center;
}
